import React, { Component } from 'react';
import moment from 'moment';
import axiosInstance from '../../main/axios';
import SearchableSelect from '../../common/form/searchableSelect';

function formatNotificacaoLabel(n) {
  const data = n.data_erro ? moment(n.data_erro).format('DD/MM/YYYY') + (n.hora_erro ? ` ${n.hora_erro}` : '') : '';
  const msg = (n.mensagem || 'Sem mensagem').substring(0, 80);
  return data ? `${data} — ${msg}` : msg;
}

function toOptions(notificacoes) {
  return (notificacoes || []).map(n => ({
    value: String(n.id),
    label: formatNotificacaoLabel(n),
  }));
}

class NotificacaoSearchableSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificacoes: [],
      loading: false,
      modoBusca: false,
    };
    this.searchTimer = null;
    this.carregarRecentes = this.carregarRecentes.bind(this);
    this.buscarNotificacoes = this.buscarNotificacoes.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentDidMount() {
    this.carregarRecentes();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.controladorId !== this.props.controladorId) {
      this.carregarRecentes();
    } else if (
      prevProps.input.value !== this.props.input.value &&
      this.props.input.value &&
      !this.state.notificacoes.some(n => String(n.id) === String(this.props.input.value))
    ) {
      this.carregarRecentes();
    }
  }

  componentWillUnmount() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  }

  carregarRecentes() {
    const { controladorId, input } = this.props;
    if (!controladorId) {
      this.setState({ notificacoes: [], loading: false, modoBusca: false });
      return;
    }

    const params = { limit: 15 };
    if (input.value) {
      params.incluir_id = input.value;
    }

    this.setState({ loading: true, modoBusca: false });
    axiosInstance
      .get(`/manutencao/controladores/${controladorId}/notificacoes`, { params })
      .then(resp => {
        this.setState({ notificacoes: resp.data || [], loading: false });
      })
      .catch(() => {
        this.setState({ notificacoes: [], loading: false });
      });
  }

  buscarNotificacoes(termo) {
    const { controladorId } = this.props;
    if (!controladorId) return;

    this.setState({ loading: true, modoBusca: true });
    axiosInstance
      .get(`/manutencao/controladores/${controladorId}/notificacoes`, { params: { q: termo } })
      .then(resp => {
        this.setState({ notificacoes: resp.data || [], loading: false });
      })
      .catch(() => {
        this.setState({ notificacoes: [], loading: false });
      });
  }

  handleSearchChange(termo) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    const texto = (termo || '').trim();
    if (!texto) {
      this.carregarRecentes();
      return;
    }

    this.searchTimer = setTimeout(() => {
      this.buscarNotificacoes(texto);
    }, 350);
  }

  render() {
    const { label, cols, input, meta } = this.props;
    const { notificacoes, loading, modoBusca } = this.state;

    return (
      <SearchableSelect
        input={input}
        meta={meta}
        label={label}
        cols={cols}
        searchPlaceholder="Pesquisar nos últimos 90 dias..."
        noResultsText={modoBusca ? 'Nenhuma notificação encontrada' : 'Nenhuma notificação recente'}
        hintText="Exibindo as 15 mais recentes. Digite para buscar no histórico do período."
        emptyOption={{ value: '', label: 'Nenhuma' }}
        options={toOptions(notificacoes)}
        filterLocally={false}
        loading={loading}
        onSearchChange={this.handleSearchChange}
      />
    );
  }
}

export default NotificacaoSearchableSelect;
